<template>
    <div>
        <!-- Modal Alterar Unidade -->
        <div class="modal fade" id="alterarUnidadeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="dados">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Unidade</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <div class="lead">{{ dados.nome_paciente }}</div>
                            <div v-if="dados.id_atendimento">#{{ dados.id_atendimento }}</div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Nova Unidade"
                                    type="select"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    required
                                    :validate="validate"
                                    v-model="nova_unidade" />
                            </div>
                        </div>

                        <div class="row" v-if="nova_unidade && nova_unidade.recepcaos && nova_unidade.recepcaos.length">
                            <div class="col col-12">
                                <az-input
                                    label="Recepção"
                                    type="select"
                                    :optionsList="nova_unidade.recepcaos"
                                    optionsData="id_recepcao"
                                    required
                                    :validate="validate"
                                    v-model="dados.id_recepcao" />
                            </div>
                        </div>

                        <div class="row" v-if="nova_unidade && nova_unidade.carros && nova_unidade.carros.length">
                            <div class="col col-12">
                                <az-input
                                    label="Carro"
                                    type="select"
                                    :optionsList="nova_unidade.carros"
                                    optionsData="id_local"
                                    required
                                    :validate="validate"
                                    v-model="dados.id_local" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            dados: null, 
            validate: false, 
            nova_unidade: "",
            nova_recepcao: "",   
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
    },

    methods: { 
        abrir(marcacao) { 
            this.validate = false;
            this.dados = _.cloneDeep(marcacao);

            $('#alterarUnidadeModal').modal('show');
        },

        atualizar () { 
            if ( this.nova_unidade ) 
                this.dados.id_unidade_operacao = this.nova_unidade.id_unidade_operacao;

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'alterar_unidade',
                dados: this.dados,
                toast: true, 
                modal: 'alterarUnidadeModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>